import { useFlags as _useFlags } from 'launchdarkly-react-client-sdk';

import type { LDFlagSet } from './flags';

export const useFlags = _useFlags<LDFlagSet>;
